export default __webpack_public_path__ + "static/media/Greenpeas.abff371c.jpg";